






import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import publicApi from '@/api/publicApi'
import * as OSS from 'ali-oss'
/**
 * 图片显示组件
 */
@Component
export default class ShowImgComponents extends Vue {
  @Prop()
  public imgUrl: string
  private client: any = {}
  private url: string = ''
  private accessKeyInfo: any = {

  }
  @Watch('imgUrl')
  protected changeUrl() {
    this.getAccessKey()
  }

  public mounted() {
    this.getAccessKey()
  }

  protected getAccessKey() {
    publicApi.getStsAccessKeyInfo({}).then((res) => {
      this.accessKeyInfo = res.data
      this.client = new OSS({
        accessKeyId: this.accessKeyInfo.accessKeyId || '',
        accessKeySecret: this.accessKeyInfo.accessKeySecret || '',
        stsToken: this.accessKeyInfo.securityToken || '',
        bucket: this.accessKeyInfo.bucketName || '',
        region: 'oss-cn-beijing'
      })
      this.url = this.client.signatureUrl(this.imgUrl)
    })
  }
}
